import { Text } from "@react-pdf/renderer";

const Answer = ({ answer }) => {
  return (
    <Text>
      {answer?.answer?.answer || "--"}
    </Text>
  )
}

export default Answer;